"use strict";

exports.unsafeCoerceEff = function (f) {
  return f;
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-eff/src/Control/Monad/Eff/Unsafe.js
// module id = 69
// module chunks = 0